import React from 'react';

import { StyleUtil } from '../../util';
import classNames from './EABD2TabButton.module.scss';

export interface TabButtonProps
  extends Readonly<{
    text: string;
    isActive: boolean;
    onPress: () => void;
  }> {}

export const TabButton = React.memo<TabButtonProps>((props) => {
  const { text, isActive, onPress } = props;

  const RootClassNames = React.useMemo<string>(() => {
    const rootClassNames = StyleUtil.createInitialClassNameArray(classNames.root);

    if (isActive) {
      rootClassNames.push(classNames.active);
    }

    return StyleUtil.mergeClassNames(rootClassNames);
  }, [isActive]);

  return (
    <button onClick={onPress} type={'button'} className={RootClassNames}>
      <span className={classNames.text}>{text}</span>
    </button>
  );
});
